import React, {useEffect, useRef, useState} from 'react';
import {StyledDropdownControl, StyleDropdownBody, StyleDropdownHeader} from "./form.styled";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

interface IProps {
    slotHeader: React.ReactNode;
    slotContent: React.ReactNode;
    className?: string;
    width?: string;
}

/**
 * DropdownControl — базовый компонент
 */


const DropdownControl = ({slotHeader, slotContent, className = "", width = "max-content"}: IProps) => {

    const [isOpen, setOpen] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);

    // Закрытие при клике вне блока (если нужно)
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <StyledDropdownControl width={width} className={`${GLOBAL_STYLE_CONFIG.splitByPrefix("dropdown-control")} ${className}`} ref={ref}>
            <StyleDropdownHeader className={`
            ${GLOBAL_STYLE_CONFIG.splitByPrefix('dropdown-control-header')}
            ${isOpen ? GLOBAL_STYLE_CONFIG.splitByPrefix('open')  : ''}`} onClick={() => setOpen(prev => !prev)}>
                {slotHeader}
                <svg className={GLOBAL_STYLE_CONFIG.splitByPrefix("icon-arrow")} width="10" height="6" viewBox="0 0 10 6" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="black" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>

            </StyleDropdownHeader>
            {isOpen && (
                <StyleDropdownBody
                className={` ${GLOBAL_STYLE_CONFIG.splitByPrefix('dropdown-control-content')}`}
                >
                    {slotContent}
                </StyleDropdownBody>
            )}
        </StyledDropdownControl>
    );
}
DropdownControl.Item = ({children}: any) => {
    return (
        <div>
            {children}
        </div>
    )
}

export default DropdownControl;